let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kO7MH")).then(() => parcelRequire('5d39M'));